<template>
  <div class="insurance">
    <p v-if="type !== 'static'"
       class="insurance-title">
      {{ $t('payment.aseguraTuEntrada') }}
    </p>
    <p v-if="type !== 'static'"
       class="insurance-text"
       v-html="$t('payment.ahoraConWegowPuedesAsegurarTusEntradasSiempreQuePuedasJustificarloTeDevolveremos')" />
    <div v-if="type !== 'static'"
         v-show="showMoreInsurance"
         class="insurance-reasons">
      <p class="insurance-reason">{{ $t('payment.enfermedad') }}</p>
      <p class="insurance-reason">
        {{ $t('payment.cambiosEnTuSituacionLaboral') }}
      </p>
      <p class="insurance-reason">
        {{ $t('payment.accidentesDeTrafico') }}
      </p>
    </div>
    <a v-if="type !== 'static'"
       class="insurance-more"
       @click="showMoreInsurance = !showMoreInsurance">
      <span v-show="showMoreInsurance">{{ $t('payment.verMenos') }}</span>
      <span v-show="!showMoreInsurance">{{ $t('payment.verMas') }}</span>
      <span v-show="!showMoreInsurance"
            class="arrow-down" />
      <span v-show="showMoreInsurance"
            class="arrow-up" />
    </a>
    <div class="insurance-price">
      <p class="insurance-price-text">
        {{ $t('payment.seguroDeNoAsistencia') }}
      </p>
      <p class="insurance-price-number">
        {{ insurancePremium || 0 }}€
      </p>
    </div>
    <div class="insurance-caser">
      <p>{{ $t('payment.aseguradoPor') }}</p>
      <img class="image"
           :src="require(`@/assets/images/caser_white.png`)"
           alt="" />
    </div>
    <div class="tAr insurance-button">
      <button v-if="!insuranceData.first_name"
              type="button"
              class="btn ghost"
              @click="$emit('openInsuranceModal')">
        {{ $t('payment.añadirSeguro') }}
      </button>
      <button v-else
              type="button"
              class="btn ghost"
              @click="removeInsurance()">
        {{ $t('payment.eliminarSeguro') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    insurancePremium: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    insuranceData: {
      type: Object,
      default: () => {}
    },
    thereIsInsurance: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMoreInsurance: false
  }),
  methods: {
    removeInsurance() {
      this.$emit('update:thereIsInsurance', false)
      this.$emit('update:insuranceData', {})
      this.$emit('removeInsurance')
    }
  }
}
</script>

<style lang="scss">
@import './insurance.sass'
</style>
